import { useNavigate } from "react-router-dom";
import { PRODUCT_TYPES } from "../constants";

export const useNaviProduct = () => {
  const navigate = useNavigate();
  const naviProduct = (props?: {
    id?: number;
    slug?: string;
    productType?: TProductType;
    newWindow?: boolean;
    params?: Record<string, string>;
  }) => {
    if (!props) return;
    const { productType, slug } = props;

    let url = "";
    switch (productType) {
      case PRODUCT_TYPES.PASS:
        url = "/pass/" + slug;
        break;

      case PRODUCT_TYPES.TOUR:
        url = "/guide-tours/" + slug;
        break;

      case PRODUCT_TYPES.TICKET:
        url = "/tickets/" + slug;
        break;

      case PRODUCT_TYPES.MUSICAL:
        url = "/musicals/" + slug;
        break;

      case PRODUCT_TYPES.SIM:
        url = "/e-sims/" + slug;
        break;

      default:
        break;
    }
    if (props.params) {
      url += "?" + new URLSearchParams(props.params).toString();
    }
    if (props.newWindow) {
      window.open(url, "_blank");
      return;
    }
    navigate(url);
  };
  return { naviProduct };
};
